<template>
  <div class="text-center">
    <v-btn
      class="ml-2"
      min-width="0"
      to="/"
      exact
    >
      Help
      <v-icon right>mdi-help</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'DefaultGoHome',
  }
</script>
